import {
  PF_SET_TOTE_SET,
  PF_SET_INPUT,
  PF_SET_STAGE,
  PF_SET_SCAN_RESULT,
  PF_CONFIRM_TOTE,
  PF_SET_ORDER_COMPLETE,
  PF_SET_SCAN_SUCCESS,
  PF_SET_SCAN_ERROR,
  PF_SET_LOADING,
  PF_SET_NOTICE,
  PF_SET_PROMPT,
  PF_SET_FOCUS,
  PF_SET_POSTSCAN,
  PF_RESET
} from '../constants';

const initialState = {
  toteSet: null,
  input: '',
  stage: 'product',
  order: null,
  suggestedItem: null,
  tote: null,
  bannerState: 'empty',
  outcome: null,
  unscannedItems: [],
  itemsInTote: [],
  pendingScan: null,
  orderComplete: false,
  completeMessage: '',
  scanSuccess: false,
  scanError: false,
  loading: false,
  notice: '',
  prompt: {isVisible: false, message: '', type: ''},
  mainInputHasFocus: true,
  // Pending completion context held while interactive post-scan modules
  // (packing cam / tracking / verify) run across screens. Lets the resume path
  // finalize (ShippingEasy/OrderCup popups + auto-reset) once modules finish.
  postScan: {active: false, popupOrder: null, resetSeconds: null}
};

export default function productFirstReducer(state = initialState, action) {
  switch (action.type) {
    case PF_SET_TOTE_SET:
      return {...state, toteSet: action.payload};
    case PF_SET_INPUT:
      return {...state, input: action.payload};
    case PF_SET_STAGE:
      return {...state, stage: action.payload};
    case PF_SET_SCAN_RESULT:
      return {...state, ...action.payload, input: '', notice: ''};
    case PF_CONFIRM_TOTE:
      return {
        ...state,
        itemsInTote: action.payload.itemsInTote,
        unscannedItems: action.payload.unscannedItems,
        suggestedItem: action.payload.suggestedItem,
        pendingScan: null,
        stage: 'product',
        input: ''
      };
    case PF_SET_ORDER_COMPLETE:
      return {
        ...state,
        orderComplete: action.payload.orderComplete,
        completeMessage: action.payload.completeMessage ?? state.completeMessage,
        itemsInTote: action.payload.itemsInTote ?? state.itemsInTote,
        unscannedItems: action.payload.unscannedItems ?? [],
        suggestedItem: null,
        pendingScan: null,
        stage: 'product',
        input: ''
      };
    case PF_SET_SCAN_SUCCESS:
      return {...state, scanSuccess: action.payload};
    case PF_SET_SCAN_ERROR:
      return {...state, scanError: action.payload};
    case PF_SET_LOADING:
      return {...state, loading: action.payload};
    case PF_SET_NOTICE:
      return {...state, notice: action.payload};
    case PF_SET_PROMPT:
      return {...state, prompt: action.payload};
    case PF_SET_FOCUS:
      return {...state, mainInputHasFocus: action.payload};
    case PF_SET_POSTSCAN:
      return {...state, postScan: {...state.postScan, ...action.payload}};
    case PF_RESET:
      return {...initialState, toteSet: state.toteSet};
    default:
      return state;
  }
}
